import { Checkbox } from '@fattureincloud/fic-design-system'
import styled from 'styled-components'

import FICColors from '../../common/FICColors'

export const Column = styled.div`
  width: 100%;
  min-height: 130px;
  background-color: ${FICColors.boxBackgroundColor};
  border-radius: 3px;
  box-sizing: border-box;
  display: inline-flex;
  flex-direction: column;
  position: relative;
  white-space: normal;
  padding: 8px;
  margin: 5px;
`
export const Footer = styled.div`
  border-radius: 0 0 3px 3px;
  color: #5e6c84;
  display: block;
  flex: 0 0 auto;
  padding: 8px;
  position: relative;
  text-decoration: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

export const Title = styled.div<{ type: SectionType }>`
  font-size: ${({ type }) =>
    type === SectionType.SubSubSection
      ? '20px'
      : type === SectionType.SubSubSubSection
      ? '15px'
      : '30px'};
  color: ${FICColors.black};
  font-weight: bold;
  padding: 5px;
  border-radius: 3px;
  text-align: left;
  margin-bottom: 8px;
  margin-top: 8px;
`

export const ArticleDrag = styled.div<{ isDragging: boolean }>`
  font-size: 16px;
  background-color: ${({ isDragging }) =>
    isDragging ? `#0294d3` : FICColors.white};
  box-shadow: ${({ isDragging }) =>
    isDragging
      ? `0px 10px 13px -7px ${FICColors.blue900}, 5px 5px 5px -2px ${FICColors.blue900}`
      : '0 1px 0 rgba(9,30,66,.25)'};
  color: ${({ isDragging }) =>
    isDragging ? FICColors.white : FICColors.textLink};
  padding: 10px;
  cursor: grab;
  border-radius: 3px;
  margin-bottom: 5px;
  word-wrap: break-word;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
  display: flex;
  justify-content: space-between;
`

export const UserContainer = styled.div<{ isDraggingOver: boolean }>`
  transition: background-color 0.2s ease;
  background-color: ${({ isDraggingOver }) =>
    isDraggingOver ? FICColors.inputDisabled : FICColors.boxBackgroundColor};
`

export const SectionTitle = styled.div`
  display: flex;
  justify-content: space-between;
  column-gap: 12px;
  align-items: end;
  margin-bottom: 12px;
`
export const FieldEditRow = styled.div`
  display: flex;
  margin-bottom: 12px;
  margin-top: 12px;
  align-items: end;
  column-gap: 12px;
`

export enum SectionType {
  Main,
  Subsection,
  SubSubSection,
  SubSubSubSection,
}

export const SectionActions = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: flex-start;
`
export const DropTitle = styled.div`
  display: flex;
  column-gap: 8px;
  align-items: center;
`
export const MoveMainPage = styled(Checkbox)`
  margin-top: 16px;
`
